import { DataSource, Label, Layout, Map } from "@mcleod/components";

export abstract class AutogenLayoutFeasibilityMap extends Layout {
    labelPracticalDistanceVendor: Label;
    mapFeasibility: Map;
    sourceFeasibility: DataSource;
}
